import type React from 'react';
import {
  type FieldType,
  type SchemaFieldType,
  type FieldMap,
} from '../types/form-fields';

export const mapFieldTypes = (
  fields: FieldMap,
  typeMap: Record<SchemaFieldType, FieldType>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, React.ComponentType<any>> => ({
  ...fields,
  ...Object.fromEntries(
    Object.entries(typeMap)
      .filter(([, targetType]) => fields[targetType])
      .map(([newName, targetType]) => [newName, fields[targetType]]),
  ),
});
